<template>
  <div class="page page__list">
    <div class="list">
      <div class="weui-cells">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in projectItem.children"
          :key="item.id"
          :to="'/doc/'+projectCode+'/'+item.code"
        >
          <div class="weui-cell__bd">
            <p>{{item.name}}</p>
          </div>
          <div class="weui-cell__ft"></div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    projectCode: String,
    projectItem: Array
  },
  beforeRouteEnter(to, from, next) {
    next(() => {
      var item = to.params.projectItem;
      if (item) {
        document.title = "帮助中心 - " + item.name;
      }
    });
  }
};
</script>